<script setup lang="ts">
//#region imports
import { computed } from 'vue';
import type { TagSize } from '@/types/core';
//#endregion

//#region define
interface Props {
  icon?: string;
  lib?: string;
  size?: TagSize;
}

interface Emits {
  click: [event: PointerEvent];
}

const props = withDefaults(defineProps<Props>(), {
  size: 'medium',
  icon: '',
});

const emit = defineEmits<Emits>();
//#endregion

//#region computed
const pSize = computed(() => {
  switch (props.size) {
  case 'large':
    return 11;
  default:
  case 'medium':
    return 10;
  }
});
//#endregion
</script>

<template>
  <span
    :class="[
      'ui-tag',
      `ui-tag_${size}`
    ]"
    @click="emit('click', $event)"
  >
    <span class="ui-tag__prepend">
      <slot name="prepend">
        <UiIcon
          v-if="icon"
          class="ui-tag__icon"
          :size="pSize"
          :name="icon"
          color=" "
        />
        <div v-else>{{ icon }}</div>
      </slot>
    </span>
    <span class="ui-tag__title">
      <slot />
    </span>
  </span>
</template>


<style lang="scss">
.ui-tag {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  background-color: var(--palette-main-primary);
  color: #ffffff;
  line-height: 100%;
  border-radius: 100px;

  &_medium {
    padding: 4px 8px;
    font-size: 10px;
  }

  &_large {
    padding: 3px 8px;
    font-size: 11px;
  }

  &__title {
    font-weight: 500;
    height: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
